import { Dispatch } from 'react';
import { CartItem, ProductType } from '../../types/product';
import { axiosInstance } from '../../utils/axios';
import { authService } from '../../utils/authService';
import { getSession } from '../../utils/user/generateSession';
import {
  ADD_TO_CART,
  ADD_TO_CART_ERROR,
  GET_CART_ITEMS,
  GET_CART_ITEMS_ERROR,
  UPDATE_CART_ITEM_ERROR,
} from './types';

export const addToCart =
  (payload: { count: number; product: ProductType }) =>
  async (
    dispatch: Dispatch<{
      type: string;
      payload: CartItem | { error: boolean; message: string };
    }>
  ) => {
    try {
      const session = getSession();
      const isLoggedIn = authService.isLoggedIn();
      let body: any = {
        count: payload.count,
        productId: payload.product.id,
      };
      if (isLoggedIn) {
        const user = authService.getCurrentUser();
        body.userId = user.id;
      } else {
        body.sessionId = session?.id;
      }
      const res = await axiosInstance.post('/v1/cart', body);
      const item = res.data.data;
      dispatch({
        type: ADD_TO_CART,
        payload: item,
      });
    } catch (error: any) {
      dispatch({
        type: ADD_TO_CART_ERROR,
        payload: {
          error: true,
          message: error!?.response!?.data!?.message
            ? error!?.response!?.data!?.message
            : error!?.message || 'something went wrong',
        },
      });
    }
  };

export const getAllCartItems =
  () =>
  async (
    dispatch: Dispatch<{
      type: string;
      payload: CartItem | { error: true; message: string };
    }>
  ) => {
    try {
      const session = getSession();
      const isLoggedIn = authService.isLoggedIn();
      let params: any = {};
      if (isLoggedIn) {
        const user = authService.getCurrentUser();
        params.userId = user.id;
      } else {
        params.sessionId = session?.id;
      }
      const res = await axiosInstance.get('/v1/cart', { params });

      dispatch({
        type: GET_CART_ITEMS,
        payload: res.data.data,
      });
    } catch (error: any) {
      dispatch({
        type: GET_CART_ITEMS_ERROR,
        payload: {
          error: true,
          message: error!?.response!?.data!?.message
            ? error!?.response!?.data!?.message
            : error!?.message || 'something went wrong',
        },
      });
    }
  };

export const updateCartItem = async (payload: {
  count: number;
  cartItemId: number;
}) => {
  try {
    const session = getSession();
    const isLoggedIn = authService.isLoggedIn();
    let body: any = {
      count: payload.count,
    };
    if (isLoggedIn) {
      const user = authService.getCurrentUser();
      body.userId = user.id;
    } else {
      body.sessionId = session?.id;
    }
    const res = await axiosInstance.put(`/v1/cart/${payload.cartItemId}`, body);
    const item = res.data.data;
    return item;
  } catch (error: any) {
    return {
      error: error!?.response!?.data!?.message
        ? error!?.response!?.data!?.message
        : error!?.message || 'something went wrong',
    };
  }
};

export const deleteCartItem = async (payload: { cartItemId: number }) => {
  try {
    const session = getSession();
    const isLoggedIn = authService.isLoggedIn();
    let params: any = {};
    if (isLoggedIn) {
      const user = authService.getCurrentUser();
      params.userId = user.id;
    } else {
      params.sessionId = session?.id;
    }
    const res = await axiosInstance.delete(`/v1/cart/${payload.cartItemId}`, {
      params,
    });
    const item = res.data.data;
    return item;
  } catch (error: any) {
    return {
      error: error!?.response!?.data!?.message
        ? error!?.response!?.data!?.message
        : error!?.message || 'something went wrong',
    };
  }
};

export const getStoreSharedCart = async (payload: URLSearchParams) => {
  try {
    const res = await axiosInstance.get('/v1/shared-cart', { params: payload });
    const items = res.data.data;
    return items;
  } catch (error: any) {
    return {
      error: error!?.response!?.data!?.message
        ? error!?.response!?.data!?.message
        : error!?.message || 'something went wrong',
    };
  }
};
